import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M5 12l14 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 12l6 6" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 12l6 -6" })
	]
});
export { SvgArrowLeft as ReactComponent };
